import templateUrl from "emun.order/parts/parts-order-details-header.htm";
import controller from "emun.order/parts/parts-order-details-header.controller";

export default {
  bindings: {
    order: "<"
  },
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};
/*
1) Part ORders - Information you type in such as comments, warranty info , invoice/ack - nothing shows up once you hit submit  
 - we need that info to be included in the part order we see.
When looking up the order/invoice/part tabs below at bottom of product - 
invoices need to show most recent (orders do show most recent but invoices show 2 years back).
  Just aggravating to have to resort to see most recent.*/

const po = {
  offset: 0,
  total: 1,
  results: [
    {
      id: "b055dab9-3de0-42c4-914f-2bf0219736da",
      createdOn: "2019-04-29T00:00:00.0000000Z",
      createdBy: "admin",
      productId: "SS638-1RL-096",
      product: {
        id: "SS638-1RL-096",
        productLineId: "HU",
        manufacturerNumber: "SS638-1RL-096",
        shortDescription: "Giancarlo RAF Chair w/ Power Motion Power Headrest",
        longDescription: "US Avail: 26",
        upcCode: "793532438594",
        status: "Active",
        pricing: {},
        listPrice: 0,
        wholesalePrice: 799,
        retailPrice: 2637,
        retailListPrice: 0,
        unitsInStock: 26,
        categoryId: "Motion",
        minimumOrderQty: 1,
        availableQty: 26,
        incomingQty: 0,
        purchaseIncrement: 0,
        vendorId: "HU",
        isB2B: true,
        isB2C: false,
        isSellable: true,
        itemType: "",
        keywords:
          "SS638-1RL-096|Giancarlo RAF Chair w/ Power Motion Power Headrest|SS638-1RL-096|HU|Motion|MS|Yes|Yes|Active|TruckLoad|",
        tags: {},
        isNew: false,
        isRestricted: true,
        isKit: false,
        isKitExplode: false,
        isKitEditable: false,
        meta: {},
        isOnDemand: false,
        createdOn: "0001-01-01T00:00:00.0000000Z",
        weight: 128.7,
        height: 0,
        length: 0,
        cubicVolume: 30.99,
        cost: 0,
        uom: "EA",
        subCategory: "MS",
        featured: 0,
        likes: 0,
        hasLiked: false,
        points: 0,
        productImages: []
      },
      status: "New",
      comments: "Comments",
      poNumber: "PO#",
      tagFor: "Tag For",
      contactName: "Contact",
      acknowledgement: "Ack",
      invoiceId: "Org Inv#",
      customerServiceEmail: "al@emunworks.com",
      shippingLocation: {
        retailerId: "CUST-100097_B2B",
        id: "CUST-100097_B2B",
        name: "EMUN 11/29 TEST Customer",
        companyName: "EMUN 11/29 TEST Customer",
        address: "100 Providence Main St NW",
        address2: "",
        city: "Huntsville",
        state: "AL",
        zip: "35806-4827",
        country: "US",
        phone: "(255) 622-2222",
        storeLocator: false,
        retailer: {
          country: "US",
          billingLocation: {
            personName: { full: "" },
            country: "US",
            meta: {}
          },
          shippingMethod: "",
          customerType: "Customer",
          status: "Active",
          isKeyAccount: false,
          isCreditHold: false,
          isSendSetupForm: false,
          residential: false,
          priceList: "",
          discount: 0,
          meta: {},
          createdOn: "2019-04-29T09:39:58.8151708-05:00",
          lastOrderedOn: "0001-01-01T00:00:00.0000000Z",
          lastContactedOn: "0001-01-01T00:00:00.0000000Z",
          lastLoginAttempt: "0001-01-01T00:00:00.0000000Z",
          salesReps: [],
          storeTypes: [],
          paymentTerm: { isCredit: false, isStandard: false },
          salesRep: {
            id: "",
            name: "",
            fullName: "",
            email: "",
            active: false,
            totalSales: 0
          },
          shipMethod: {},
          openOrders: 0,
          openOrdersTotal: 0,
          totalSales: 0,
          totalOrders: 0,
          lastOrderTotal: 0,
          region: {},
          territory: {},
          tags: {},
          poRequired: false,
          balance: 0,
          past1Days: 0,
          past30Days: 0,
          past60Days: 0,
          past90Days: 0
        },
        createdOn: "2019-04-29T09:39:58.8151708-05:00",
        salesReps: [],
        paymentTerm: { isCredit: false, isStandard: false },
        shipMethod: {},
        meta: {},
        storeCategory: "CUST-100097_B2B",
        status: "Active"
      },
      retailer: {
        id: "CUST-100097_B2B",
        companyName: "EMUN 11/29 TEST Customer",
        address: "100 Providence Main St NW",
        address2: "",
        city: "Huntsville",
        state: "AL",
        zip: "35806-4827",
        country: "US",
        billingLocation: {
          companyName: "EMUN 11/29 TEST Customer",
          personName: { full: "" },
          address: "100 Providence Main St NW",
          address2: "",
          city: "Huntsville",
          state: "AL",
          zip: "35806-4827",
          country: "US",
          meta: {}
        },
        phone: "(255) 622-2222",
        fax: "",
        contact: "EMUN Test Contact1",
        paymentTerms: "004",
        shippingMethod: "",
        notes: "",
        accountType: "",
        customerType: "Customer",
        status: "Active",
        isKeyAccount: false,
        isCreditHold: false,
        isSendSetupForm: false,
        residential: false,
        email: "",
        website: "",
        federalTaxID: "",
        stateTaxID: "",
        defaultShipOn: "9998-12-01T00:00:00.0000000Z",
        priceList: "",
        discount: 0,
        meta: {},
        createdOn: "2018-11-30T07:22:49.0000000Z",
        lastOrderedOn: "2018-11-30T00:00:00.0000000Z",
        lastContactedOn: "2018-12-01T12:40:23.4900000Z",
        lastLoginAttempt: "0001-01-01T00:00:00.0000000Z",
        salesReps: [],
        storeTypes: [],
        paymentTerm: { isCredit: false, isStandard: false },
        salesRep: {
          id: "",
          name: "",
          fullName: "",
          email: "",
          active: false,
          totalSales: 0
        },
        shipMethod: {},
        openOrders: 0,
        openOrdersTotal: 0,
        totalSales: 0,
        totalOrders: 0,
        lastOrderTotal: 0,
        territoryId: "",
        regionId: "",
        region: {},
        territory: {},
        keywords:
          "CUST-100097_B2B|EMUN 11/29 TEST Customer|Huntsville|AL|35806-4827|(255) 622-2222||",
        tags: {},
        poRequired: false,
        balance: 0,
        past1Days: 0,
        past30Days: 0,
        past60Days: 0,
        past90Days: 0,
        restrictionGroup: ""
      },
      lines: [
        {
          id: "3e5e8ae1-b92c-4ef3-8fa8-87972c468603",
          position: 1,
          productId: "5179196",
          product: {
            id: "5179196",
            manufacturerNumber: "5179196",
            shortDescription: "Raffel Battery Pack (Optional)",
            longDescription: "US Avail: 60",
            status: "Active",
            pricing: {},
            listPrice: 0,
            wholesalePrice: 100,
            retailListPrice: 0,
            unitsInStock: 60,
            minimumOrderQty: 1,
            availableQty: 60,
            incomingQty: 0,
            purchaseIncrement: 0,
            isB2B: false,
            isB2C: false,
            isSellable: false,
            keywords:
              "5179196|Raffel Battery Pack (Optional)|5179196|TruckLoad|",
            tags: { Warehouse: ["TruckLoad"] },
            isNew: false,
            isRestricted: false,
            isKit: false,
            isKitExplode: false,
            isKitEditable: false,
            meta: {},
            isOnDemand: false,
            createdOn: "2019-04-29T09:39:58.8181703-05:00",
            weight: 0,
            height: 0,
            length: 0,
            cubicVolume: 0,
            cost: 0,
            shipOn: "2019-04-29T09:39:58.8181703-05:00",
            featured: 0,
            likes: 0,
            hasLiked: false,
            points: 0,
            productImages: []
          },
          reason: "Reason",
          quantity: 1,
          qtyPurchased: 1,
          extendedTotal: 100
        }
      ],
      itemCount: 1,
      qtyPurchased: 1,
      weight: 0,
      cubicVolume: 0,
      freight: 0,
      refund: 0,
      giftCardDiscount: 0,
      grandTotal: 100
    }
  ]
};
